import React from "react";
import { BrowserRouter, Route as R, Switch } from "react-router-dom";
import CreateAccount from "./views/CreateAccount";
import Login from "./views/Login";
import RequestResetPassword from "./views/RequestResetPassword";
import ResetPassword from "./views/ResetPassword";
import VerifyAccountCard from "./components/CreateAccount/VerifyAccountCard";
import Reactivate from "./views/Reactivate";
import RedirectInvalid from "./components/shared/RedirectInvalid";
import Maintenance from "./views/Maintenance";
import SSOLogin from "./views/SSOLogin";

const Route: any = R;
const Router: React.FC = () => (
  <BrowserRouter>
    <Switch>
      <Route
        path="/create-account"
        exact
        component={CreateAccount}
        isPublic
        publicOnly
        title="Create Account"
      />
      <Route
        path="/create-account/verify"
        exact
        component={VerifyAccountCard}
        isPublic
        publicOnly
        title="Verify"
      />
      {/* These will be uncommented when the full login process is set up */}
      {/* {window.__env__.REACT_APP_FEATURE_FLAG_APP_NAME.indexOf('client_sso_auth') >= 0 ?
        <Route
          path="/login"
          exact
          component={SSOLogin}
          isPublic
          publicOnly
          title="Login"
        />
        :
        <Route
          path="/login"
          exact
          component={Login}
          isPublic
          publicOnly
          title="Login"
        />
      } */}
      {/* These two will be removed once the entire login process is set up */}
      <Route
        path="/testlogin"
        exact
        component={SSOLogin}
        isPublic
        publicOnly
        title="Login"
      />
      <Route
        path="/login"
        exact
        component={Login}
        isPublic
        publicOnly
        title="Login"
      />
      {/* end delete later */}
      <Route
        path="/login/reset"
        exact
        component={RequestResetPassword}
        isPublic
        publicOnly
        title="Reset Password"
      />
      <Route
        path="/login/reset/:resetToken"
        exact
        component={ResetPassword}
        isPublic
        publicOnly
        title="Reset Password"
      />
      <Route
        path="/login/reactivate/:token"
        exact
        component={Reactivate}
        isPublic
        publicOnly
        title="Reactivate"
      />
      <Route
        path="/maintenance"
        exact
        component={Maintenance}
        isPublic
        publicOnly
        title="Maintenance"
      />
      <Route component={RedirectInvalid} />
    </Switch>
  </BrowserRouter>
);

export default Router;
